import { apiClient } from './AbstractHTTPService';
const PATH = '/menu/'

export default {
  getMenu () {
    return apiClient.get(PATH)
  }
}
